export default ({ store }: any) => {
  store.dispatch('gdpr/initializeGdprClient')
}
